// extracted by mini-css-extract-plugin
export var header = "header-module--header--d10c5";
export var logoHorizontal = "header-module--logoHorizontal--3199b";
export var logoLink = "header-module--logoLink--52c0f";
export var logoVertical = "header-module--logoVertical--5a845";
export var nav = "header-module--nav--a7ffd";
export var navLink = "header-module--navLink--d2c4f";